var React = require('react');

function Clear (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"common-actions/clear_24"),React.createElement("path",{"d":"M12-.0001c6.627 0 12 5.373 12 12 0 6.627-5.373 12-12 12-6.627 0-12-5.373-12-12 0-6.627 5.373-12 12-12zm0 23c6.065 0 11-4.935 11-11 0-6.065-4.935-11-11-11-6.065 0-11 4.935-11 11 0 6.065 4.935 11 11 11zm3.8904-14.8203c.193.192.193.508 0 .701l-3.155 3.154 3.155 3.155c.193.192.193.508 0 .701-.193.192-.508.192-.701 0l-3.154-3.154-3.155 3.154c-.193.192-.508.192-.701 0-.193-.193-.193-.509 0-.701l3.155-3.155-3.155-3.154c-.193-.193-.193-.509 0-.701.193-.193.508-.193.701 0l3.155 3.154 3.154-3.154c.193-.193.508-.193.701 0z","fill":"#000","fillRule":"evenodd","key":1})]);
}

Clear.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Clear;

Clear.default = Clear;
